module.exports = __webpack_public_path__ + "static/media/commissionsHand.4543f620.svg";